/**
 * MY — Resignation of Director (M32106) Register Detail 매핑.
 * TASK_DATA.formData.directors[] (또는 presetForm.values 폴백으로 빌드된 directors) 사용.
 */
import { registerRegisterDetail } from '@/features/startTask/preset_task/shared/preset/register/registerDetailRegistry';
import { formatDocDate } from '@/shared/composables/dateUtils';

function formatSessionDate(raw: any): string {
  const s = String(raw || '').trim();
  if (!s) return '';
  try {
    return formatDocDate(s) || s;
  } catch {
    return s;
  }
}

registerRegisterDetail('M32106', {
  title: 'Resigning Director Details',
  repeatArrayPath: 'directors',
  fields: [
    { label: 'Full Name', key: ['directors.0.fullName'] },
    { label: 'NRIC / Passport No', key: ['directors.0.nricOrPassport'] },
    {
      label: 'Date of Appointment',
      key: ['directors.0.appointmentDate', 'directors.0.dateOfAppointment'],
      format: formatSessionDate,
    },
    {
      label: 'Date of Cessation',
      key: [
        'directors.0.dateOfCessation',
        'directors.0.cessationDate',
        'directors.0.date_of_cessation',
      ],
      format: formatSessionDate,
    },
    { label: 'Residential Address', key: ['directors.0.residentialAddress'] },
    {
      label: 'Reason for cessation',
      key: ['directors.0.reasonForCessation', 'directors.0.reason'],
    },
  ],
});
